import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,on,findIn, findAllIn, hasClass, closest} from '@elements/dom-utils';
import Popover from 'bootstrap/js/dist/popover';

const selectors = {
    base: '.js-advantages',
    item: '.js-advantages__item',
    button: '.js-advantages__button',
    close: '.js-advantages__button-close'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let buttons = findAllIn(selectors.button, baseElement);
        let items = findAllIn(selectors.item, baseElement);
        let close = findAllIn(selectors.close, baseElement);

        buttons.forEach((button, index) => {
            const popover = new Popover(button, {
                html: true,
                trigger: 'manual',
                title: '',
                content: items[index],
                placement: 'bottom',
                customClass: 'advantages-popover',
                delay: {
                    "show": 100,
                    "hide": 100
                },
            });


            on('click', function () {
                if(!hasClass('is-open', button)) {
                    addClass('is-open', button);
                    items[index].removeAttribute('hidden');
                    popover.show();

                    on('click', function(evt) {
                        removeClass('is-open', button);
                        popover.hide();
                        items[index].setAtttribute('hidden', true);
                    }, close[index])
                } else {
                    popover.hide();
                    removeClass('is-open', button);
                    items[index].setAtttribute('hidden', true);
                }
            }, button);


        })
    });
}
